module.exports = __webpack_public_path__ + "assets/img/c0cf145de64ee56aab683233c2964467.png";